import { useMemo } from 'react'

import { AgChartOptions } from 'ag-charts-community'

import { CustomAgChart } from '@fortem-monorepo/react-ag'
import { ICReport } from '@fortem-monorepo/web-sdk'

import { ICReportChartPrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { protection } from '@/react-query/queries/ic-report/hooks'

export interface ProtectionScenarioChartProps extends ICReportChartPrimitive {}

export const ProtectionScenarioChart: React.FC<ProtectionScenarioChartProps> = ({
  options,
  params,
}) => {
  const query = protection.useHistoricalEventsNew({
    ...params,
  })

  const data = query.data?.data ?? []

  const datas = useMemo(() => {
    return data.reduce(
      (prev, curr) => {
        const _new = { ...prev }
        if (!_new[curr.long_name]) {
          _new[curr.long_name] = [curr]
        } else {
          _new[curr.long_name].push(curr)
        }
        return _new
      },
      {} as Record<string, typeof data>,
    )
  }, [data])

  const getKey = (key: ICReport.GetScenarioAnalysisProtectionData['data'][number]['long_name']) => {
    const map: Record<typeof key, string> = {
      total_t: 'Total (T)',
      total_tmo: 'Total (T-1)',
    }

    return map[key] ?? key
  }

  const mergedOptions: AgChartOptions<ICReport.GetScenarioAnalysisProtectionData['data'][number]> =
    {
      height: 500,
      series: Object.entries(datas).map(([key, datum]) => ({
        data: datum,
        type: 'bar',
        xKey: 'shock_name',
        yKey: 'return',
        yName: getKey(key),
      })),
      axes: [
        {
          type: 'category',
          position: 'bottom',
        },
        {
          type: 'number',
          position: 'left',
          label: {
            formatter: (val) => `${(val.value * 100).toFixed(2)}%`,
          },
        },
      ],
      ...options,
    }

  return <CustomAgChart options={mergedOptions} />
}
